module.exports = __webpack_public_path__ + "img/UTGREA-4.1263064f.jpg";